/**
 * Is the front door signup, or the waiting list?
 *
 * The server decides — `INVITE_ONLY` — and the browser has to ask, because a
 * build-time constant would go stale the moment the flag is flipped. The page
 * would then offer a signup form the server refuses, or hide one it would have
 * accepted; both look like the product is broken.
 *
 * Cached per page load. It cannot change mid-session in a way that matters,
 * and every auth screen asks.
 */
import { api } from "@/lib/api";

let inflight = null;

export function resetSignupModeCache() {
  inflight = null;
}

export async function fetchSignupMode() {
  if (!inflight) {
    inflight = api
      .get("/auth/signup-mode")
      .then(({ data }) => ({ inviteOnly: Boolean(data?.invite_only) }))
      // Unreachable => assume open signup. Guessing "invite-only" would hide
      // the signup form from everyone during a blip; guessing "open" shows a
      // form the server will refuse with a message that explains itself.
      .catch(() => ({ inviteOnly: false }));
  }
  return inflight;
}
